export default function Avatar({className, size, src, ...props}) {

    return (
        <img className={`  object-cover rounded-full ${size ? size : "w-8 h-8"} ${className} `} src={
            src ? src : "/icons/user-icon.svg"
        } alt={"Avatar"} {...props}  />


    )
}